module.exports = __webpack_public_path__ + "static/img/lisa_g.8f07b0fd.png";